(function () {
  var STORAGE_KEY = 'fabrique_login_pending';
  var LOGIN_ERROR_SELECTOR = '[data-login-error="true"]';
  var SHOP_LOGIN_SELECTOR = '.sign-in-with-shop-provider';
  var ACCOUNT_AUTH_SELECTOR = '[data-account-authenticated="true"]';
  var LOGIN_PENDING_TTL = 10 * 60 * 1000;

  function pushEvent(eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName
    });
  }

  function getStorageValue(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorageValue(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function removeStorageValue(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function parsePending(raw) {
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function readPending() {
    var sessionPending = parsePending(getStorageValue(window.sessionStorage, STORAGE_KEY));
    var localPending = parsePending(getStorageValue(window.localStorage, STORAGE_KEY));

    if (!sessionPending) {
      return localPending;
    }

    if (!localPending) {
      return sessionPending;
    }

    return (sessionPending.createdAt || 0) >= (localPending.createdAt || 0)
      ? sessionPending
      : localPending;
  }

  function writePending(partialPending) {
    var pending = readPending() || {};
    var nextPending = {
      method: partialPending.method || pending.method || 'unknown',
      loginPath: partialPending.loginPath || pending.loginPath || getLoginPath(),
      createdAt: partialPending.createdAt || Date.now()
    };
    var payload = JSON.stringify(nextPending);

    setStorageValue(window.sessionStorage, STORAGE_KEY, payload);
    setStorageValue(window.localStorage, STORAGE_KEY, payload);
  }

  function clearPending() {
    removeStorageValue(window.sessionStorage, STORAGE_KEY);
    removeStorageValue(window.localStorage, STORAGE_KEY);
  }

  function hasFreshPending(pending) {
    if (!pending || !pending.createdAt) {
      return false;
    }

    return Date.now() - pending.createdAt <= LOGIN_PENDING_TTL;
  }

  function normalizePath(path) {
    if (!path) {
      return '/';
    }

    return path.replace(/\/+$/, '') || '/';
  }

  function getPathFromUrl(url) {
    try {
      return normalizePath(new URL(url, window.location.origin).pathname);
    } catch (error) {
      return normalizePath(url);
    }
  }

  function getLoginPath() {
    var config = window.FABRIQUE_LOGIN_TRACKING || {};
    return getPathFromUrl(config.loginPath || '/account/login');
  }

  function getAccountPath() {
    var config = window.FABRIQUE_LOGIN_TRACKING || {};
    return getPathFromUrl(config.accountPath || '/account');
  }

  function getCurrentPath() {
    return normalizePath(window.location.pathname);
  }

  function isLoginPage() {
    return getCurrentPath() === getLoginPath();
  }

  function isAccountPage() {
    return getCurrentPath() === getAccountPath();
  }

  function hasAccountInfo() {
    return !!document.querySelector(ACCOUNT_AUTH_SELECTOR);
  }

  function ensureLoginPagePending() {
    var pending = readPending();

    if (!isLoginPage()) {
      return;
    }

    if (pending && hasFreshPending(pending) && pending.loginPath === getLoginPath()) {
      return;
    }

    writePending({
      loginPath: getLoginPath(),
      createdAt: Date.now()
    });
  }

  function bindLoginAttemptTracking() {
    var loginForm = document.getElementById('customer_login');
    var shopLoginArea = document.querySelector(SHOP_LOGIN_SELECTOR);

    if (loginForm) {
      loginForm.addEventListener('submit', function () {
        writePending({
          method: 'password',
          loginPath: getLoginPath(),
          createdAt: Date.now()
        });
      });
    }

    if (shopLoginArea) {
      shopLoginArea.addEventListener(
        'click',
        function () {
          writePending({
            method: 'shop',
            loginPath: getLoginPath(),
            createdAt: Date.now()
          });
        },
        true
      );
    }
  }

  function resolveLoginResult() {
    var pending = readPending();
    var loginErrorNode = document.querySelector(LOGIN_ERROR_SELECTOR);

    if (!pending) {
      return;
    }

    if (!hasFreshPending(pending)) {
      clearPending();
      return;
    }

    if (
      isLoginPage()
      && pending.method === 'password'
      && loginErrorNode
    ) {
      pushEvent('Log_in_fail');
      clearPending();
      return;
    }

    if (
      pending.loginPath === getLoginPath()
      && isAccountPage()
      && hasAccountInfo()
    ) {
      pushEvent('Log_in_success');
      clearPending();
    }
  }

  function bindExitTracking() {
    var registerLinks = document.querySelectorAll('a[href*="/account/register"]');
    var index = 0;

    for (index = 0; index < registerLinks.length; index += 1) {
      var link = registerLinks[index];
      link.addEventListener('click', function () {
        clearPending();
      });
    }
  }

  function bindReturnVerification() {
    window.addEventListener('pageshow', resolveLoginResult);
    window.addEventListener('focus', resolveLoginResult);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        resolveLoginResult();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    ensureLoginPagePending();
    bindLoginAttemptTracking();
    bindExitTracking();
    bindReturnVerification();
    resolveLoginResult();
  });
})();